import { render, staticRenderFns } from "./CreateKnowledgePage.vue?vue&type=template&id=075de71d&scoped=true"
import script from "./CreateKnowledgePage.vue?vue&type=script&lang=js"
export * from "./CreateKnowledgePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075de71d",
  null
  
)

export default component.exports